(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('document-work-item-action', {
            parent: 'entity',
            url: '/document-work-item-action',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItemAction.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-actions.html',
                    controller: 'DocumentWorkItemActionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItemAction');
                    $translatePartialLoader.addPart('workItemActionType');
                    $translatePartialLoader.addPart('workItemActionStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('document-work-item-action-detail', {
            parent: 'entity',
            url: '/document-work-item-action/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'jmrsignApp.documentWorkItemAction.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-detail.html',
                    controller: 'DocumentWorkItemActionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documentWorkItemAction');
                    $translatePartialLoader.addPart('workItemActionType');
                    $translatePartialLoader.addPart('workItemActionStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DocumentWorkItemAction', function($stateParams, DocumentWorkItemAction) {
                    return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'document-work-item-action',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('document-work-item-action-detail.edit', {
            parent: 'document-work-item-action-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-dialog.html',
                    controller: 'DocumentWorkItemActionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItemAction', function(DocumentWorkItemAction) {
                            return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item-action.new', {
            parent: 'document-work-item-action',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-dialog.html',
                    controller: 'DocumentWorkItemActionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                seqNo: null,
                                startDate: null,
                                endDate: null,
                                textData: null,
                                imageData: null,
                                imageDataContentType: null,
                                pageNo: null,
                                xPos: null,
                                yPos: null,
                                type: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('document-work-item-action', null, { reload: 'document-work-item-action' });
                }, function() {
                    $state.go('document-work-item-action');
                });
            }]
        })
        .state('document-work-item-action.edit', {
            parent: 'document-work-item-action',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-dialog.html',
                    controller: 'DocumentWorkItemActionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DocumentWorkItemAction', function(DocumentWorkItemAction) {
                            return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item-action', null, { reload: 'document-work-item-action' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('document-work-item-action.delete', {
            parent: 'document-work-item-action',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/document-work-item-action/document-work-item-action-delete-dialog.html',
                    controller: 'DocumentWorkItemActionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DocumentWorkItemAction', function(DocumentWorkItemAction) {
                            return DocumentWorkItemAction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('document-work-item-action', null, { reload: 'document-work-item-action' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
